import { NgModule } from '@angular/core';
import { AuthStatePersistenceService } from '@spartacus/core';
import { CustomAuthStatePersistenceService } from './auth-state-persistence.service';

@NgModule({
  providers: [
    {
      provide: AuthStatePersistenceService,
      useExisting: CustomAuthStatePersistenceService,
    },
  ],
})
export class CustomAuthStatePersistenceModule {}
